import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import HotelOffersSkeleton from '../components/HotelOffersSkeleton/HotelOffersSkeleton';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

class AppHotelOffersPage extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allOffers: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.type = '';
    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = type;
    }

    // Bind "this"
    this.loadHotelOffers = this.loadHotelOffers.bind(this);
    this.loadMoreHotelOffers = this.loadMoreHotelOffers.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadHotelOffers() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTEL_OFFERS,
      'type': this.type,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = [...response.data['offers']];

          if (offersCount > 0) {
            this.setState({
              loading: false,
              allOffers: [...offers],
              loadMoreLoading: false,
              loadedAll: offersCount == offers.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreHotelOffers() {
    const {
      allOffers,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTEL_OFFERS,
        'type': this.type,
        'offset': allOffers.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const offersCount = response.data['offers_count'];
            const offers = [
              ...allOffers,
              ...response.data['offers'],
            ];

            if (offersCount > 0) {
              this.setState({
                loading: false,
                allOffers: [...offers],
                loadMoreLoading: false,
                loadedAll: offersCount == offers.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentDidMount() {
    // Load hotel offers on first page load
    this.loadHotelOffers();

    $(document).on(constants.EVENT_SELECT_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadHotelOffers();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading)
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      loading,
      allOffers,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        {
          !loading && allOffers.length > 0 && (
            <div className="row rooms-slider">
              {
                allOffers.map((offer, i) => {
                  return (
                    <div className="col-12 col-lg-6 mb-4 px-2 px-lg-3" key={i}>
                      <a href={offer['link']} className="single-room-wrapper d-block">
                        <div className="preview-images">
                          <div className="featured-image bg-center position-relative" style={{backgroundImage: `url(${offer['image']})`}} />
                        </div>
                        <div className="room-info balance-elements">
                          {
                            offer['types'].length > 0 && (
                              <React.Fragment>
                                {
                                  offer['types'].map((type, i) => {
                                    return (
                                      <span className="badge badge-dark mr-2 mb-3 bg-red p-2 text-uppercase" key={i}>
                                        {type}
                                      </span>
                                    );
                                  })
                                }
                              </React.Fragment>
                            )
                          }
                          {
                            offer['name'].length > 0 && (
                              <h2 className="name mb-0">{offer['name']}</h2>
                            )
                          }
                          {
                            offer['description'] && (
                              <div className="description">
                                <p dangerouslySetInnerHTML={{__html: offer['description']}} />
                              </div>
                            )
                          }
                          {
                            offer['price_label'] && (
                              <div className="price">
                                {offer['price_label']}
                              </div>
                            )
                          }
                        </div>
                      </a>
                    </div>
                  );
                })
              }
            </div>
          )
        }
        {
          (loading || loadMoreLoading) && (
            <HotelOffersSkeleton />
          )
        }
        {
          (loading || loadMoreLoading || allOffers.length > 0) && (
            <div className="row justify-content-center">
              <button className="btn btn-red btn-lg btn-border-red btn-load-more mt-3" disabled={loading || loadMoreLoading || loadedAll } onClick={this.loadMoreHotelOffers}>
                {!loadedAll ? 'Load More' : 'That\'s All'}
              </button>
            </div>
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' || $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    // Hotel offers
    const hotelOffersWrapper = $('#hotel-offers-wrapper');
    if (hotelOffersWrapper.length) {
      ReactDOM.render(<AppHotelOffersPage />, hotelOffersWrapper[0]);
    }

    const hotelOffersFilter = $('#hotel-offers-filter');
    if (hotelOffersFilter.length) {
      hotelOffersFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_SELECT_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelOffersPage.js